module.exports = __webpack_public_path__ + "static/img/5bg_9.4d3cb91.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/5bg_9.png
// module id = 734
// module chunks = 1